import { z } from 'zod';

const PageSchema = z.object({
  id: z.string(),
  title: z.string(),
  url: z.string(),
});

export type BaselineNavigationPage = z.infer<typeof PageSchema>;

const BaselineNavigationItemSchema = z.object({
  page: PageSchema,
});

export type BaselineNavigationItem = z.infer<
  typeof BaselineNavigationItemSchema
>;

const BaselineNavigationSchema = z.object({
  data: z.array(BaselineNavigationItemSchema),
});

export type BaselineNavigationResponse = z.infer<
  typeof BaselineNavigationSchema
>;

export { BaselineNavigationSchema };
